import { render, staticRenderFns } from "./immunofingerprint.vue?vue&type=template&id=11e7d3d8&scoped=true"
import script from "./immunofingerprint.vue?vue&type=script&lang=js"
export * from "./immunofingerprint.vue?vue&type=script&lang=js"
import style0 from "./immunofingerprint.vue?vue&type=style&index=0&id=11e7d3d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e7d3d8",
  null
  
)

export default component.exports